import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	item: {
		display: "block",
		marginTop: 10,
		[theme.breakpoints.up("lg")]: {
			width: "50%"
		},
		"& picture": {
			display: "block",
			overflow: "hidden"
		},
		"& img": {
			transition: "transform 500ms ease"
		},
		"& img:hover": {
			transform: "scale(1.05)"
		}
	},
	link: {
		fontSize: "5vw",
		color: "#FFFFFF",
		textAlign: "center",
		[theme.breakpoints.up("sm")]: {
			fontSize: 24
		},
		[theme.breakpoints.up("lg")]: {
			fontSize: 32,
			maxWidth: 957,
			padding: "0 16px 5px",
			textAlign: "left"
		}
	}
}));

export default styles;
